import React, { Component } from "react";
import { Collapse } from "antd";
import ChangePassword from "./ChangePassword";
import Certificates from "./Certificates";
const Panel = Collapse.Panel;

class CollapseMenu extends Component {
  render() {
    return (
      <Collapse
        bordered={false}
        defaultActiveKey={["1"]}
        style={{ backgroundColor: "transparent" }}
      >
        <Panel
          className="custom-panel"
          header={<span style={{ color: "#595959" }}>Cambiar Contraseña</span>}
          key="1"
        >
          <ChangePassword />
        </Panel>
        <Panel
          className="custom-panel"
          header={<span style={{ color: "#595959" }}>Certificados</span>}
          key="2"
        >
          <Certificates user={this.props.user} />
        </Panel>
      </Collapse>
    );
  }
}

export default CollapseMenu;



// WEBPACK FOOTER //
// ./src/Components/Profile/CollapseMenu.js